"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerDialogStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _datePickerTheme = require("./datePickerTheme");
const DatePickerDialogStyled = (0, _styled.default)("div")`
    display: flex;
    flex-direction: column;
    align-items: stretch;

    box-sizing: border-box;
    background: ${_datePickerTheme.datePickerTheme.backgroundColor};
    ${_ref => {
  let {
    themeMode
  } = _ref;
  return `
        box-shadow: ${_datePickerTheme.datePickerTheme.boxShadow[themeMode]};
        border-radius: ${_datePickerTheme.datePickerTheme.borderRadius[themeMode]};
        padding: ${_datePickerTheme.datePickerTheme.padding[themeMode]};
    `;
}}
`;
exports.DatePickerDialogStyled = DatePickerDialogStyled;
//# sourceMappingURL=DatePickerDialogStyled.js.map